import React, {useMemo} from "react";
import PropTypes from "prop-types";
import {useNavigate} from "react-router-dom";

// Utils
import getFilteredNotificationGroups from "./filteredNotificationUtils.js";

// Components
import Modal from "../../components/Modal.js";

// Style
import {
  HeadingCenter,
  Text,
  Label,
  List,
  ListItem,
  Inline,
  Button
} from "../../style/components/general.js";

/**
 * Shown after a checksheet goes live when the save response lists filtered Overdue /
 * Outstanding groups it won't reach. Renders nothing when there are none.
 */
const ModalFilteredNotifications = ({notifications, onClose, slug}) => {
  const navigate = useNavigate();

  const groups = useMemo(() => getFilteredNotificationGroups(notifications), [notifications]);

  if (groups.length === 0) return null;

  const reviewNotifications = () => {
    onClose();
    navigate(`/facilities/${slug}/notifications`);
  };

  return (
    <Modal visible setVisible={visible => !visible && onClose()}>
      <Inline column data-testid="filteredNotifications.modal">
        <HeadingCenter>Filtered Notifications</HeadingCenter>
        <Text>
          This checksheet will not be included automatically in these filtered notifications. Add
          it on the Notifications page, or acknowledge to leave it out.
        </Text>
        <List column>
          {groups.map(({key, label, schedule, recipients, checksheetCount}) => (
            <ListItem key={key}>
              <Label bold>{label}</Label>
              {` · ${schedule} · ${recipients} · ${checksheetCount} checksheet${
                checksheetCount === 1 ? "" : "s"
              }`}
            </ListItem>
          ))}
        </List>
        <Inline>
          <Button type="button" onClick={reviewNotifications}>
            Review notifications
          </Button>
          <Button type="button" onClick={onClose}>
            Acknowledge
          </Button>
        </Inline>
      </Inline>
    </Modal>
  );
};

ModalFilteredNotifications.propTypes = {
  notifications: PropTypes.objectOf(PropTypes.object),
  onClose: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired
};

ModalFilteredNotifications.defaultProps = {
  notifications: null
};

export default ModalFilteredNotifications;
